<template>
  <div class="forbidden-page">
    <div class="error-content">
      <div class="error-icon">🚫</div>
      <h1 class="error-title">403</h1>
      <h2 class="error-subtitle">{{ $t('common.noPermission') }}</h2>
      <p class="error-message">{{ $t('Forbidden.line7_text') }}</p>
      <div class="action-buttons">
        <button class="btn btn-primary" @click="goBack">
          ← 返回上一页
        </button>
        <button class="btn btn-secondary" @click="goToLogin">
          返回登录
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Forbidden',
  methods: {
    goBack() {
      // 检查是否有 token
      const token = localStorage.getItem('auth_token');
      if (!token) {
        // 没有 token，调用 logout
        this.handleLogout();
      } else {
        // 有 token，返回上一页
        this.$router.back();
      }
    },
    goToLogin() {
      this.handleLogout();
    },
    handleLogout() {
      // 清除所有认证信息
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_identity');
      localStorage.removeItem('identityId');
      localStorage.removeItem('userId');
      // 跳转到登录页
      this.$router.replace('/login');
    }
  }
};
</script>

<style scoped>
.forbidden-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.error-content {
  text-align: center;
  color: #fff;
  padding: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  max-width: 500px;
}

.error-icon {
  font-size: 80px;
  margin-bottom: 20px;
}

.error-title {
  font-size: 120px;
  font-weight: 700;
  margin: 0;
  line-height: 1;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.error-subtitle {
  font-size: 32px;
  margin: 20px 0 10px;
  font-weight: 600;
}

.error-message {
  font-size: 18px;
  opacity: 0.9;
  margin: 10px 0 30px;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.btn {
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.3s;
}

.btn-primary {
  background: #fff;
  color: #667eea;
}

.btn-primary:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 2px solid #fff;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .error-title {
    font-size: 80px;
  }
  
  .error-subtitle {
    font-size: 24px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}
</style>
